/**************************************************
 * Nombre:       Formulario_Producto_Foto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoImagenCropLista from "../../../Modulo_formularios/Componentes/IngresoImagenCropLista";

const Formulario_Producto_Foto = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoImagenCropLista dato={'imgs'} {...props} alto={1} ancho={1}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Foto